import { useState } from 'react';
import { Mail, Phone, MapPin, Send, CheckCircle2 } from 'lucide-react';

import '../assets/css/contact.css';


export default function Contact() {
    const [formData, setFormData] = useState({ name: '', email: '', message: '' });
    const [errors, setErrors] = useState({});
    const [status, setStatus] = useState('idle'); // idle | sending | sent

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (errors[e.target.name]) setErrors({ ...errors, [e.target.name]: null });
    };

    const validate = () => {
        const next = {};
        if (!formData.name.trim()) next.name = 'Nom requis';
        if (!formData.email.trim()) next.email = 'Email requis';
        else if (!/^\S+@\S+\.\S+$/.test(formData.email)) next.email = 'Email invalide';
        if (!formData.message.trim()) next.message = 'Décris ton projet en quelques mots';
        setErrors(next);
        return Object.keys(next).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setStatus('sending');
        // TODO : remplace ce bloc par l'appel EmailJS (option A des notes ci-dessus)
        await new Promise((resolve) => setTimeout(resolve, 900));
        setStatus('sent');
        setFormData({ name: '', email: '', message: '' });
    };

    return (
        <>
            <section className="contact-page">
                <div className="contact-header">
                    <span className="eyebrow">Contact</span>
                    <h1>Travaillons ensemble</h1>
                    <p>
                        Un projet à développer, un besoin en support production
                        monétique, ou juste une question ? Écris-moi.
                    </p>
                </div>

                <div className="contact-body">
                    <div className="contact-info">
                        <a href="mailto:mahjoubimhmmd@gmail.com" className="info-item">
                            <Mail size={18} />
                            <span>mahjoubimhmmd@gmail.com</span>
                        </a>
                        <a href="tel:+212688877277" className="info-item">
                            <Phone size={18} />
                            <span>+212 6 88 87 72 77</span>
                        </a>
                        <div className="info-item">
                            <MapPin size={18} />
                            <span>Ain Sebaa, Casablanca</span>
                        </div>
                    </div>

                    <form className="contact-form" onSubmit={handleSubmit} noValidate>
                        {status === 'sent' ? (
                            <div className="success-state">
                                <CheckCircle2 size={32} />
                                <h3>Message envoyé</h3>
                                <p>Merci, je reviens vers toi rapidement.</p>
                                <button type="button" className="btn-secondary" onClick={() => setStatus('idle')}>
                                    Envoyer un autre message
                                </button>
                            </div>
                        ) : (
                            <>
                                <div className="field">
                                    <label htmlFor="name">Nom</label>
                                    <input
                                        id="name"
                                        name="name"
                                        type="text"
                                        placeholder="Votre nom"
                                        value={formData.name}
                                        onChange={handleChange}
                                        aria-invalid={!!errors.name}
                                    />
                                    {errors.name && <span className="field-error">{errors.name}</span>}
                                </div>

                                <div className="field">
                                    <label htmlFor="email">Email</label>
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        placeholder="vous@exemple.com"
                                        value={formData.email}
                                        onChange={handleChange}
                                        aria-invalid={!!errors.email}
                                    />
                                    {errors.email && <span className="field-error">{errors.email}</span>}
                                </div>

                                <div className="field">
                                    <label htmlFor="message">Votre projet</label>
                                    <textarea
                                        id="message"
                                        name="message"
                                        rows={5}
                                        placeholder="Décrivez votre besoin..."
                                        value={formData.message}
                                        onChange={handleChange}
                                        aria-invalid={!!errors.message}
                                    />
                                    {errors.message && <span className="field-error">{errors.message}</span>}
                                </div>

                                <button type="submit" className="btn-primary" disabled={status === 'sending'}>
                                    {status === 'sending' ? 'Envoi...' : <>Envoyer <Send size={16} /></>}
                                </button>
                            </>
                        )}
                    </form>
                </div>
            </section>
        </>
    );
}
